export enum ThreeComboOlympusSoundType {
  // 3ComboOlympus Sounds
  ThreeComboOlympus_BGBgm = '3ComboOlympus_BGBgm', // +

  ThreeComboOlympus_SymbolThunder = '3ComboOlympus_SymbolThunder', // +
  ThreeComboOlympus_SymbolOut = '3ComboOlympus_SymbolOut', // +
  ThreeComboOlympus_SymbolEnter = '3ComboOlympus_SymbolEnter', // +
  ThreeComboOlympus_SymbolClear = '3ComboOlympus_SymbolClear', // +
  ThreeComboOlympus_SymbolReplenish = '3ComboOlympus_SymbolReplenish', // +
  ThreeComboOlympus_SymbolTip = '3ComboOlympus_SymbolTip', // ++

  ThreeComboOlympus_FrameExpand = '3ComboOlympus_FrameExpand', // +
  ThreeComboOlympus_MultiplyValue = '3ComboOlympus_MultiplyValue', // ++
  ThreeComboOlympus_TotalMultiply = '3ComboOlympus_TotalMultiply',
  ThreeComboOlympus_MultiplyTOTumble = '3ComboOlympus_MultiplyTOTumble', // ++
  ThreeComboOlympus_Retirgger = '3ComboOlympus_Retrigger', // +
  ThreeComboOlympus_BGIntroIn_loop = '3ComboOlympus_BGIntroIn_loop', // +
  ThreeComboOlympus_BGIntroIn = '3ComboOlympus_BGIntroIn', // +
  ThreeComboOlympus_BGIntroOut = '3ComboOlympus_BGIntroOut', // +

  ThreeComboOlympus_PotTrigger = '3ComboOlympus_PotTrigger', // ++
  ThreeComboOlympus_TotalWin = '3ComboOlympus_TotalWin', // ++
  ThreeComboOlympus_Ring = '3ComboOlympus_Ring', // ++
  ThreeComboOlympus_PotCollect = '3ComboOlympus_PotCollect', // ++
  ThreeComboOlympus_FrameRegain = '3ComboOlympus_FrameRegain',
  ThreeComboOlympus_PotLvUp = '3ComboOlympus_PotLvUp', // ++
  ThreeComboOlympus_BuyBonus = '3ComboOlympus_BuyBonus', // ++
  ThreeComboOlympus_Expand = '3ComboOlympus_Expand',
  ThreeComboOlympus_Wild = '3ComboOlympus_Wild',
  ThreeComboOlympus_Multiplier = '3ComboOlympus_Multiplier',
  ThreeComboOlympus_Dual = '3ComboOlympus_Dual',
  // ThreeComboOlympus_WinningPanel_Bigwin = '3ComboOlympus_WinningPanel_Bigwin',
  // ThreeComboOlympus_WinningPanel_BigwinEnd = '3ComboOlympus_WinningPanel_BigwinEnd',
  // ThreeComboOlympus_WinningPanel_Megawin = '3ComboOlympus_WinningPanel_Megawin',
  // ThreeComboOlympus_WinningPanel_MegawinEnd = '3ComboOlympus_WinningPanel_MegawinEnd',
  // ThreeComboOlympus_WinningPanel_SuperMegawin = '3ComboOlympus_WinningPanel_SuperMegawin',
  // ThreeComboOlympus_WinningPanel_SuperMegaEnd = '3ComboOlympus_WinningPanel_SuperMegaEnd',
  // ThreeComboOlympus_WinningPanel_big2supermegawin = '3ComboOlympus_WinningPanel_big2supermegawin',
  // ThreeComboOlympus_WinningPanel_Big2megawin = '3ComboOlympus_WinningPanel_Big2megawin',
  Olympus_WinningPanel_bigwin = 'Olympus_WinningPanel_bigwin',
  Olympus_WinningPanel_bigwinEnd = 'Olympus_WinningPanel_bigwinEnd',
  Olympus_WinningPanel_megawin = 'Olympus_WinningPanel_megawin',
  Olympus_WinningPanel_megawinEnd = 'Olympus_WinningPanel_megawinEnd',
  Olympus_WinningPanel_superwin = 'Olympus_WinningPanel_superwin',
  Olympus_WinningPanel_superwinEnd = 'Olympus_WinningPanel_superwinEnd',
  Olympus_WinningPanel_big2megawin = 'Olympus_WinningPanel_big2megawin',
  Olympus_WinningPanel_big2superwin = 'Olympus_WinningPanel_big2superwin',
}

export enum godziSoundType {
  // Godzi Drop Sounds
  Godzi_BGM = 'Godzi_BGM',
  Godzi_Efx_BetterLuck = 'Godzi_Efx_BetterLuck',
  Godzi_Efx_Egg_Colored = 'Godzi_Efx_Egg_Colored',
  Godzi_Efx_Egg_Golden = 'Godzi_Efx_Egg_Golden',
  Godzi_Efx_Egg_Silver = 'Godzi_Efx_Egg_Silver',
  Godzi_Efx_Feature = 'Godzi_Efx_Feature',
  Godzi_Efx_Godzi = 'Godzi_Efx_Godzi',
  Godzi_Efx_Total_Win = 'Godzi_Efx_Total Win',
}

export enum voucherSoundType {
  // Voucher Sounds
  Voucher_ButtonClick = 'Voucher_ButtonClick',
  Voucher_VoucherPlayingUI_GiftRetracts = 'Voucher_VoucherPlayingUI_GiftRetracts',
  Voucher_VoucherPlayingUI_ShowUp = 'Voucher_VoucherPlayingUI_ShowUp',
  Voucher_VoucherPopUp = 'Voucher_VoucherPopUp',
  Voucher_VoucherTotalWin = 'Voucher_VoucherTotalWin',
}
